import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [MatIcon, NgClass],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  @Input({ required: true }) type: 'warn';
  @Input({ required: true }) message: string;

  get typeClass(): string {
    return 'alert--' + this.type;
  }
}
